/**
 * Deep merges two objects, combining their properties recursively
 */
export function deepMerge(target, source) {
    const output = { ...target };
    for (const key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            if (typeof source[key] === 'object' &&
                source[key] !== null &&
                !Array.isArray(source[key]) &&
                typeof output[key] === 'object' &&
                output[key] !== null &&
                !Array.isArray(output[key])) {
                output[key] = deepMerge(output[key], source[key]);
            }
            else {
                output[key] = source[key];
            }
        }
    }
    return output;
}
/**
 * Safely formats an object to a JSON string, handling circular references
 */
export function safeStringify(obj, indent = 2) {
    try {
        // Handle circular references
        const seen = new WeakSet();
        return JSON.stringify(obj, (_key, value) => {
            if (typeof value === 'object' && value !== null) {
                if (seen.has(value)) {
                    return '[Circular Reference]';
                }
                seen.add(value);
            }
            return value;
        }, indent);
    }
    catch (error) {
        return `Error formatting data: ${error instanceof Error ? error.message : String(error)}`;
    }
}
//# sourceMappingURL=objectUtils.js.map